import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import TwoColumnLayout from "layout/TwoColumnLayout";
import DeletePaymentModal from "Payment/DeletePaymentModal";
import { PaymentDetailSection } from "Payment/PaymentDetailSection";
import React from "react";
import { useLoaderData } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";

const PaymentDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.PaymentDetailFrontModel>();

  const { payment, optionsPanel } = viewModel;
  const [isDeleting, setIsDeleting] = React.useState(false);

  const links = [{
    text: RESX.Buttons.ListView,
    href: routes.payment_List().absolute,
    visible: true
  },
  ...payment.permissions.canDelete
    ? [{
      text: RESX.Buttons.btnDelete,
      onClick: () => { setIsDeleting(true); },
      visible: true
    }]
    : []
  ];

  return <>
    <PanelSegmentType>
      <PanelSegmentType.Header size="h2header">
        <PanelSegmentType.Title title={RESX.Payment.resxPayment} />
      </PanelSegmentType.Header>
    </PanelSegmentType>

    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        <PaymentDetailSection
          payment={payment}
        />
      </TwoColumnLayout.LeftColumn>
      <TwoColumnLayout.RightColumn>
        <GeneralOptionsPanel
          links={links}
          data={optionsPanel}
        />
      </TwoColumnLayout.RightColumn>
    </TwoColumnLayout>
    <DeletePaymentModal
      payment={payment}
      isOpen={isDeleting}
      onClose={() => { setIsDeleting(false); }}
    />
  </>;
};

export default PaymentDetailApp;